export default __webpack_public_path__ + "static/media/grao.9267a291.webp";